export default "__VITE_ASSET__GcPNg8mC__"